import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { ReactNode, useEffect } from 'react';
import { isBlank } from '../../util/isBlank';

const ReactQueryDevtoolsProduction = React.lazy(() =>
    import('@tanstack/react-query-devtools/build/modern/production.js').then(x => ({ default: x.ReactQueryDevtools }))
);

function isDevelopmentEnvironment(): boolean {
    const NODE_ENV = import.meta.env.MODE;
    return isBlank(NODE_ENV) || NODE_ENV === 'development';
}

function ConsoleLaunchedReactQueryDevtools(): ReactNode | null {
    const [showDevtools, setShowDevtools] = React.useState(false);

    useEffect(() => {
        (window as any).toggleReactQueryDevtools = () => {
            setShowDevtools(value => !value);
        };
    }, []);

    if (!showDevtools) {
        return null;
    }

    if (isDevelopmentEnvironment()) {
        return <ReactQueryDevtools initialIsOpen />;
    }

    return (
        <React.Suspense fallback={null} key="react-query-devtools-production">
            <ReactQueryDevtoolsProduction />
        </React.Suspense>
    );
}

export default ConsoleLaunchedReactQueryDevtools;
